// extracted by mini-css-extract-plugin
export default {"iconTab":"ParticipantsTabs-module-a42688cd38f0c69f1fec"};